<template>
    <v-container>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-card class="mx-auto px-2 pt-2">
            <v-toolbar flat dark class="indigo lighten-3">
                <v-toolbar-title>Transaction Report</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <v-breadcrumbs :items="$store.state.routes" divider=" | "></v-breadcrumbs>
                <v-data-table
                    :headers="headers"
                    :items="transactions"
                    :loading="loading"
                    hide-default-footer
                    :items-per-page="itemsPerPage"
                    fixed-header
                    height="50vh"                    
                >
                    <template v-slot:top>
                        <v-row>
                            <v-col cols="12" lg="4" md="4">
                                <v-select
                                    :items="filteredActivityTypes"
                                    v-model="activityType"
                                    outlined
                                    dense
                                    item-text="text"
                                    item-value="value"
                                    label="ActivityType"
                                    placeholder="ActivityType"
                                ></v-select>
                            </v-col>
                            <v-col cols="12" lg="4" md="4">
                                <v-select
                                    :items="filteredDestinations"
                                    item-value="value"
                                    item-text="text"
                                    outlined
                                    dense
                                    label="Destination"
                                    placeholder="Destination"
                                    v-model="destination"
                                ></v-select>
                            </v-col>
                            <v-col cols="12" lg="4" md="4">
                                <v-text-field
                                    label="Search by container_number..."
                                    prepend-inner-icon="mdi-magnify"
                                    v-model="search"
                                    outlined
                                    dense
                                    @keyup="searchByKeyword()"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <!--Date Picker(FromDate) start-->
                        <v-menu
                            v-model="menu"
                            :close-on-content-click="true"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-if="$store.state.user.role === 'sitc' || $store.state.user.role == 'tsline' || $store.state.user.role == 'msk' || $store.state.user.role == 'dp' || $store.state.user.role == 'su' || $store.state.user.role == 'surveyor' || $store.state.user.role == 'admin'"
                                    v-model="fromDate"
                                    label="FromDate"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    outlined
                                    dense
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="fromDate"
                            ></v-date-picker>
                        </v-menu>                            
                        <v-slider
                            v-model="fromTime"
                            :min="0"
                            :max="1440"
                            :step="1"
                            thumb-label="always"
                            @change="loadTransactions2()"
                        >
                            <template v-slot:thumb-label="{ value }">
                            {{ formatTime(value) }}
                            </template>
                        </v-slider>                                              
                        <!--Date Picker(FromDate) finish-->
                        <!--Date Picker(UntilDate) start-->
                        <v-menu
                            v-model="menu2"
                            :close-on-content-click="true"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-if="$store.state.user.role === 'sitc' || $store.state.user.role == 'tsline' || $store.state.user.role == 'msk' || $store.state.user.role == 'dp' || $store.state.user.role == 'su' || $store.state.user.role == 'surveyor' || $store.state.user.role == 'admin'"
                                    v-model="untilDate"
                                    label="UntilDate"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    outlined
                                    dense
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="untilDate"
                            ></v-date-picker>
                        </v-menu>                            
                        <v-slider
                            v-model="untilTime"
                            :min="0"
                            :max="1440"
                            :step="1"
                            thumb-label="always"
                            @change="loadTransactions2()"
                        >
                            <template v-slot:thumb-label="{ value }">
                            {{ formatTime(value) }}
                            </template>
                        </v-slider>                                                 
                        <!--Date Picker(UntilDate) finish-->
                        <v-btn
                            block
                            dark
                            color="blue"
                            @click="openInventoryMovementReportDialog()"
                            class="my-2"
                            max-width="100%"
                            :disabled="$store.state.user.role === 'sitc' || $store.state.user.role == 'tsline' || $store.state.user.role == 'msk'"
                        >
                            <v-icon>mdi-list-box</v-icon>
                            inventory movement report
                        </v-btn>        
                        <v-btn
                            block
                            dark
                            color="green"
                            @click="downloadInventoryMovementReportMain()"
                            class="my-2"
                            max-width="100%"
                        >
                            <v-icon>mdi-microsoft-excel</v-icon>
                            Download Excel
                        </v-btn>                                                               
                        <p># of records: <span style="color: red; font-weight: bold;">{{totalNumberOfRecords}}</span></p>
                        <div>
                        <v-pagination
                                v-model="page"
                                :length="pageCount"
                                total-visible="10"
                                dark
                                @input="changePage()"
                            ></v-pagination>
                        </div>                         
                    </template>
                    <template v-slot:[`item.container_located_at`]="{ item }">
                        <div v-if="item.container_located_at">
                            {{ item.container_located_at }}
                        </div>
                        <div v-else>
                            <v-btn
                                color="orange"
                                dark
                                small
                                v-if="item.job_order?.gate_in_at"
                                @click="openLocation1SelectionFormDialog(item)"
                                :disabled="$store.state.user.role === 'sitc' || $store.state.user.role == 'dp' || $store.state.user.role == 'tsline' || $store.state.user.role == 'msk'"
                            >
                                <v-icon>mdi-timetable</v-icon>
                                put timestamp
                            </v-btn>
                        </div>
                    </template>
                    <template v-slot:[`item.job_order_status`]="{ item }">
                        {{ jobOrderStatus(item) }}
                    </template>
                    <template v-slot:[`item.gate_in`]="{ item }">
                        <div v-if="item.job_order">
                            <div v-if="!item.job_order?.gate_in_at">
                                <v-btn
                                    color="orange"
                                    dark
                                    small
                                    @click="gateIn(item)"
                                    :disabled="item.status_history[0]?.status.status_code == 'REJECTED' || !item.remark_id || $store.state.user.role === 'sitc' || $store.state.user.role == 'dp' || $store.state.user.role == 'tsline' || $store.state.user.role == 'msk'"
                                >
                                    <v-icon>mdi-boom-gate-arrow-up</v-icon> Gate In
                                </v-btn>
                            </div>
                            <div v-else>
                                {{item.job_order?.gate_in_at}}
                            </div>
                        </div>
                    </template>
                    <template v-slot:[`item.equipment_control`]="{ item }">
                        <v-btn
                            color="blue"
                            dark
                            small
                            v-if="item.survey_id"
                            @click="openequipmentControlDialog(item)"
                        >
                            <v-icon>mdi-image</v-icon>
                            Equipment Control
                        </v-btn>
                    </template>                    
                    <template v-slot:[`item.pictures`]="{ item }">
                        <div v-if="item.remark_id">
                            <v-badge
                                color="red"
                                overlap
                                :content="item.pictures.length"
                            >
                            <v-icon
                                color="green"
                                size="35"
                                @click="openImagesDialog(item)"
                            >mdi-image</v-icon>
                            </v-badge>
                        </div>
                    </template>                    
                    <template v-slot:[`item.container_location2`]="{ item }">
                        <div v-if="!item.container_location2">
                            <v-btn
                                color="orange"
                                dark
                                small
                                @click="openLocation2SelectionFormDialog(item)"
                                :disabled="!item.job_order?.job_closed_at || $store.state.user.role === 'sitc' || $store.state.user.role == 'dp' || $store.state.user.role == 'tsline' || $store.state.user.role == 'msk'"
                            >
                            <v-icon>mdi-map-marker</v-icon> Set Location2
                        </v-btn>
                        </div>
                        <div v-else>
                            {{item.container_location2}}
                        </div>                        
                    </template>
                    <template v-slot:[`item.created_at`]="{ item }">
                        {{ item.created_at | formatDate }}
                    </template>
                </v-data-table>
                <div class="text-center pt-2">
                    <v-pagination
                        v-model="page"
                        :length="pageCount"
                        total-visible="10"
                        dark
                        @input="changePage()"
                    ></v-pagination>
                </div>
            </v-card-text>
        </v-card>

        <!-- inventoryMovementReportDialog start -->
        <v-dialog v-model="inventoryMovementReportDialog" fullscreen>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
            <v-card flat>
                <v-container>
                    <v-toolbar flat dark class="indigo lighten-3">
                        <v-toolbar-title>
                            <!-- <div v-if="dates[0] !== dates[1] && dates[1]">
                                Inventory Movement Report - gate_in_at: {{ dates[0] + ' ~ ' + dates[1] }} -
                            </div>
                            <div v-else>
                                Inventory Movement Report - gate_in_at: {{ dates[0] }} - {{ formatTimeRange(timeRange1, timeRange2) }}
                            </div>                             -->
                            <!-- Inventory Movement Report - gate_in_at: {{ fromDate + ' ' + formatTimeRange(timeRange1) + ' ~ ' + untilDate + ' ' + formatTimeRange(timeRange2) }} - -->
                            Inventory Movement Report - gate_in_at: {{ fromDate + ' ' + formatFromTime(fromTime) + ' ~ ' + untilDate + ' ' + formatUntilTime(untilTime) }} -
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                            icon
                            dark
                            @click="inventoryMovementReportDialog = false"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-btn
                            block
                            dark
                            color="green"
                            @click="downloadInventoryMovementReport()"
                            class="my-2"
                            max-width="100%"
                        >
                            <v-icon>mdi-microsoft-excel</v-icon>
                            Download Excel
                        </v-btn>         
                        <v-data-table
                            :headers="inventoryMovementReportHeaders"
                            :items="inventoryMovementReportData"
                        >
                            <template v-slot:[`item.total`]="{ item }">
                                <span style="color: red;">
                                    {{ getTotal(item) }}
                                </span>
                            </template>
                        </v-data-table>

                        <v-simple-table>
                            <template v-slot:default>
                            <thead>
                                <tr>
                                <th class="text-left">
                                    Booking
                                </th>
                                <th class="text-left">
                                    Survey
                                </th>
                                <th class="text-left">
                                    Rejected
                                </th>
                                <th class="text-left">
                                    Survey Only
                                </th>
                                <th class="text-left">
                                    Gate In
                                </th>
                                <th class="text-left">
                                    Stackyard
                                </th>
                                <th class="text-left">
                                    Job Start
                                </th>
                                <th class="text-left">
                                    Job Close
                                </th>
                                <th class="text-left">
                                    Gate Out
                                </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        {{ calculateColumnTotal(inventoryMovementReportData, 'S-01') }}
                                    </td>
                                    <td>
                                        {{ calculateColumnTotal(inventoryMovementReportData, 'S-02') }}
                                    </td>
                                    <td>
                                        {{ calculateColumnTotal(inventoryMovementReportData, 'S-03') }}
                                    </td>
                                    <td>
                                        {{ calculateColumnTotal(inventoryMovementReportData, 'S-04') }}
                                    </td>
                                    <td>
                                        {{ calculateColumnTotal(inventoryMovementReportData, 'S-05') }}
                                    </td>
                                    <td>
                                        {{ calculateColumnTotal(inventoryMovementReportData, 'S-06') }}
                                    </td>
                                    <td>
                                        {{ calculateColumnTotal(inventoryMovementReportData, 'S-07') }}
                                    </td>
                                    <td>
                                        {{ calculateColumnTotal(inventoryMovementReportData, 'S-08') }}
                                    </td>
                                    <td>
                                        {{ calculateColumnTotal(inventoryMovementReportData, 'S-09') }}
                                    </td>
                                </tr>
                            </tbody>
                            </template>
                        </v-simple-table>

                    </v-card-text>
                </v-container>
            </v-card>
        </v-dialog>
        <!-- inventoryMovementReportDialog end -->
        <!-- imagesDialog start -->
        <v-dialog v-model="imagesDialog" fullscreen>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
            <v-card flat>
                <v-container>
                    <v-toolbar flat dark class="indigo lighten-3">
                        <v-toolbar-title
                        >Pictures -- ContainerNumber: {{currentContainerNumber}} --</v-toolbar-title
                        >
                        <v-spacer></v-spacer>
                        <v-btn
                            icon
                            dark
                            @click="imagesDialog = false"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-data-table
                            :headers="pictureHeaders"
                            :items="pictures"
                            :items-per-page="-1"
                        >
                            <!-- <template v-slot:[`item.view_pictures`]="{ item }">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon
                                            color="green"
                                            @click="downloadPicture(item)"
                                            large
                                            v-on="on"
                                            :disabled="item.file_name === '-'"
                                        >mdi-image</v-icon>
                                    </template>
                                    <span>View Picture</span>
                                </v-tooltip>
                            </template> -->
                            <template v-slot:[`item.view_pictures`]="{ item }">
                                <a :href="item.tempUrl" target="_blank">
                                    <v-img
                                        v-if="item.tempUrl"
                                        :src="item.tempUrl"
                                        max-width="200"
                                        max-height="200"
                                        contain
                                    />           
                                </a>
                            </template>                            
                            <template v-slot:[`item.damage_pictures`]="{ item }">
                                <div v-if="item.damage_pictures.length > 0">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-badge
                                                color="red"
                                                overlap
                                                :content="item.damage_pictures.length"
                                            >
                                                <v-icon
                                                    color="blue"
                                                    @click="openDamagePicturesDialog(item)"
                                                    large
                                                    v-on="on"
                                                >mdi-image</v-icon>
                                            </v-badge>
                                        </template>
                                        <span>View Damage Picture</span>
                                    </v-tooltip>
                                </div>
                            </template>
                            <template v-slot:[`item.post_service_pictures`]="{ item }">
                                <div v-if="item.post_service_pictures.length > 0">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-badge
                                                color="red"
                                                overlap
                                                :content="item.post_service_pictures.length"
                                            >
                                                <v-icon
                                                    color="blue"
                                                    @click="openPostServicePicturesDialog(item)"
                                                    large
                                                    v-on="on"
                                                >mdi-image</v-icon>
                                            </v-badge>
                                        </template>
                                        <span>View Post Service Picture</span>
                                    </v-tooltip>
                                </div>
                            </template>
                            <template v-slot:[`item.created_at`]="{ item }">
                                {{ item.created_at | formatDate }}
                            </template>>
                        </v-data-table>
                    </v-card-text>
                </v-container>
            </v-card>
        </v-dialog>
        <!--imagesDialog end -->
        <!-- damagePicturesDialog start -->
        <v-dialog v-model="damagePicturesDialog" fullscreen>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
            <v-card flat>
                <v-container>
                    <v-toolbar flat dark class="indigo lighten-3">
                        <v-toolbar-title
                        >Damage Pictures -- ContainerNumber: {{currentContainerNumber}} --</v-toolbar-title
                        >
                        <v-spacer></v-spacer>
                        <v-btn
                            icon
                            dark
                            @click="damagePicturesDialog = false"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-data-table
                            :headers="damagePictureHeaders"
                            :items="damagePictures"
                            :items-per-page="-1"
                        >
                            <template v-slot:[`item.download_damage_picture`]="{ item }">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon
                                            color="green"
                                            @click="downloadDamagePicture(item)"
                                            large
                                            v-on="on"
                                        >mdi-image</v-icon>
                                    </template>
                                    <span>View Picture</span>
                                </v-tooltip>
                            </template>
                            <template v-slot:[`item.damage_pictures`]="{ item }">
                                <div v-if="item.damage_pictures.length > 0">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-badge
                                                color="red"
                                                overlap
                                                :content="item.damage_pictures.length"
                                            >
                                                <v-icon
                                                    color="blue"
                                                    @click="openDamagePicturesDialog(item)"
                                                    large
                                                    v-on="on"
                                                >mdi-image</v-icon>
                                            </v-badge>
                                        </template>
                                        <span>View Damage Picture</span>
                                    </v-tooltip>
                                </div>
                            </template>
                            <template v-slot:[`item.created_at`]="{ item }">
                                {{ item.created_at | formatDate }}
                            </template>>
                        </v-data-table>
                    </v-card-text>
                </v-container>
            </v-card>
        </v-dialog>
        <!--damagePicturesDialog end -->
        <!-- postServicePicturesDialog start -->
        <v-dialog v-model="postServicePicturesDialog" fullscreen>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
            <v-card flat>
                <v-container>
                    <v-toolbar flat dark class="indigo lighten-3">
                        <v-toolbar-title
                        >Post Service Pictures -- ContainerNumber: {{currentContainerNumber}} --</v-toolbar-title
                        >
                        <v-spacer></v-spacer>
                        <v-btn
                            icon
                            dark
                            @click="postServicePicturesDialog = false"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-data-table
                            :headers="postServicePictureHeaders"
                            :items="postServicePictures"
                            :items-per-page="-1"
                        >
                            <template v-slot:[`item.download_post_service_picture`]="{ item }">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon
                                            color="green"
                                            @click="downloadPostServicePicture(item)"
                                            large
                                            v-on="on"
                                        >mdi-image</v-icon>
                                    </template>
                                    <span>View Picture</span>
                                </v-tooltip>
                            </template>
                            <template v-slot:[`item.created_at`]="{ item }">
                                {{ item.created_at | formatDate }}
                            </template>>
                        </v-data-table>
                    </v-card-text>
                </v-container>
            </v-card>
        </v-dialog>
        <!--damagePicturesDialog end -->
        <!-- location1SelectionFormDialog start -->
        <v-dialog v-model="location1SelectionFormDialog" fullscreen>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
            <v-card flat>
                <v-container>
                    <v-toolbar flat dark class="indigo lighten-3">
                        <v-toolbar-title
                        >Select Location1 -- ContainerNumber: {{currentContainerNumber}} --</v-toolbar-title
                        >
                        <v-spacer></v-spacer>
                        <v-btn
                            icon
                            dark
                            @click="location1SelectionFormDialog = false"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-select
                            label="Container Location"
                            :items="containerLocations"
                            item-text="container_location"
                            item-value="container_location_id"
                            outlined
                            dense
                            v-model="container_location"
                        ></v-select>
                        
                        <v-btn
                            v-if="container_location"
                            color="green"
                            block
                            dark
                            @click="putTimestampInContainerLocatedAt()"
                        >
                            <v-icon>mdi-map-marker</v-icon>
                            Save Location1 & Put the Timestamp
                        </v-btn>                        
                    </v-card-text>
                </v-container>
            </v-card>
        </v-dialog>
    <!-- location1SelectionFormDialog end -->
    <!-- location2SelectionForDialog start -->
    <v-dialog v-model="location2SelectionFormDialog" fullscreen>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
            <v-card flat>
                <v-container>
                    <v-toolbar flat dark class="indigo lighten-3">
                        <v-toolbar-title>
                            Select Location2 -- Container#: {{ currentContainerNumber }}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                            icon
                            dark
                            @click="location2SelectionFormDialog = false"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-select
                                    outlined
                                    dense
                                    label="Container Location2"
                                    placeholder="Container Location2"
                                    v-model="containerLocation2"
                                    :items="containerLocations2"
                                ></v-select>
                                <v-btn
                                    v-if="containerLocation2"
                                    color="green"
                                    dark
                                    block
                                    @click="setLocation2()"
                                    :disabled="$store.state.user.role == 'dp' || $store.state.user.role === 'sitc' || $store.state.user.role == 'tsline' || $store.state.user.role == 'msk'"
                                >
                                    <v-icon>mdi-map-marker</v-icon>
                                    Set Location2 & put the timestamp
                                </v-btn>                                
                    </v-card-text>
                </v-container>
            </v-card>
        </v-dialog>
        <!-- location2SelectionForDialog end -->  
        <!-- equipmentControlDialog start -->
        <v-dialog v-model="equipmentControlDialog" fullscreen>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
            <v-card flat>
                <v-container>
                    <v-toolbar flat dark class="indigo lighten-3">
                        <v-toolbar-title
                        >Equipment Control -- ContainerNumber: {{currentContainerNumber}} --</v-toolbar-title
                        >
                        <v-spacer></v-spacer>
                        <v-btn
                            icon
                            dark
                            @click="equipmentControlDialog = false"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-btn
                            block
                            dark
                            color="green"
                            @click="spreadSheetGenerationTest()"
                            class="my-2"
                        >
                            <v-icon>mdi-microsoft-excel</v-icon>
                            download equipment control
                        </v-btn>                         
                        <v-simple-table>
                            <thead>
                                <tr>
                                    <th>Date & Time</th>
                                    <th>Container#</th>
                                    <th>Size</th>
                                    <th>Type</th>
                                    <th>Class</th>
                                    <th>Mfg. Date</th>
                                    <th>EIR No.</th>
                                    <th>Vessel & Voyage</th>
                                    <th>CEDEX Code</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td></td>
                                    <td>{{ currentContainerNumber }}</td>
                                    <td>{{ currentContainerSize }}</td>
                                    <td>{{ currentContainerType }}</td>
                                    <td>{{ currentContainerClass }}</td>
                                    <td>{{ currentManufacturingDate }}</td>
                                    <td>{{ currentTransactionId }}</td>
                                    <td></td>
                                    <td>{{ currentCedexCode }}</td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                        <v-divider class="my-5"></v-divider>
                        <v-simple-table>
                            <thead>
                                <tr>
                                    <th>ServiceId</th>
                                    <th>PartName</th>
                                    <th>Desc.</th>
                                    <th>Location</th>
                                    <th>WayOfRepair</th>
                                    <th>Hour</th>
                                    <th>MaterialCost</th>
                                    <th>LaborCost</th>
                                    <th>TotalAmount</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(jos, i) in currentJobOrderServices" :key="i">
                                    <td>{{ jos.service.service_id }}</td>
                                    <td>{{ jos.service.part_name }}</td>
                                    <td>{{ jos.service.description }}</td>
                                    <td>{{ jos.service.location }}</td>
                                    <td>{{ jos.service.way_of_repair }}</td>
                                    <td>{{ jos.service.hour }}</td>
                                    <td>{{ jos.service.material_cost }}</td>
                                    <td>{{ jos.service.labor_cost }}</td>
                                    <td>{{ jos.service.material_cost + jos.service.labor_cost }}</td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                        <v-divider class="my-5"></v-divider>
                        <v-toolbar flat dark class="indigo lighten-3">
                            <v-toolbar-title
                            >Service Picture(s)</v-toolbar-title
                            >
                        </v-toolbar>     
                        <v-divider class="my-5"></v-divider>                   
                        <v-row>
                            <v-col
                            v-for="(url, i) in pictureTempUrls"
                            :key="i"
                            class="d-flex child-flex"
                            cols="4"
                            >
                                <a :href="url" target="_blank">
                                    <v-img
                                        :src="url"

                                        aspect-ratio="1"
                                        class="grey lighten-2"
                                    >
                                        <template v-slot:placeholder>
                                        <v-row
                                            class="fill-height ma-0"
                                            align="center"
                                            justify="center"
                                        >
                                            <v-progress-circular
                                            indeterminate
                                            color="grey lighten-5"
                                            ></v-progress-circular>
                                        </v-row>
                                        </template>
                                    </v-img>
                                </a>
                            </v-col>
                        </v-row>
                        <v-divider class="my-5"></v-divider>   
                        <v-toolbar flat dark class="indigo lighten-3">
                            <v-toolbar-title
                            >Damage Picture(s)</v-toolbar-title
                            >
                        </v-toolbar>     
                        <v-divider class="my-5"></v-divider>     
                        <v-row>
                            <v-col
                            v-for="(url, i) in damagePictureTempUrls"
                            :key="i"
                            class="d-flex child-flex"
                            cols="4"
                            >
                                <a :href="url" target="_blank">
                                    <v-img
                                        :src="url"

                                        aspect-ratio="1"
                                        class="grey lighten-2"
                                    >
                                        <template v-slot:placeholder>
                                        <v-row
                                            class="fill-height ma-0"
                                            align="center"
                                            justify="center"
                                        >
                                            <v-progress-circular
                                            indeterminate
                                            color="grey lighten-5"
                                            ></v-progress-circular>
                                        </v-row>
                                        </template>
                                    </v-img>
                                </a>
                            </v-col>
                        </v-row>                                             
                    </v-card-text>
                </v-container>
            </v-card>
        </v-dialog>
        <!--equipmentControlDialog end-->               
    </v-container>
</template>
<script>
import moment from "moment";

export default {
    data() {
        return {
            search: null,
            overlay: false,
            loading: false,
            imagesDialog: false,
            pageCount: 0,
            page: 1,
            itemsPerPage: 30,
            totalNumberOfRecords: null,
            activityType: 'ALL',
            destination: 'ALL',
            destinations: [],
            menu: false,
            fromDate: `${moment().format('YYYY')}-${moment().format('MM')}-${moment().format('DD')}`,
            menu2: false,
            untilDate: `${moment().format('YYYY')}-${moment().format('MM')}-${moment().format('DD')}`,
            // dates: [
            //     `${moment().format('YYYY')}-${moment().format('MM')}-01`,
            //     `${moment().format('YYYY')}-${moment().format('MM')}-${moment().daysInMonth()}`
            // ],
            timeRange1: [0, 1440],
            timeRange2: [0, 1440],
            fromTime: 0,
            untilTime: 1440,
            // fromTime1: '00:00:00',
            // untilTime1: '24:00:00',            
            // fromTime2: '00:00:00',
            // untilTime2: '24:00:00',            
            headers: [
                {
                    text: "TransactionId",
                    value: "transaction_id",
                    sortable: false,
                },
                {
                    text: "Container#",
                    value: "container_number",
                    sortable: false,
                },
                {
                    text: "CompanyName",
                    value: "company.name",
                    sortable: false,
                },
                {
                    text: "Remark",
                    value: "remark.remark_name",
                    sortable: false,
                },
                {
                    text: "Destination",
                    value: "destination.destination_type",
                    sortable: false,
                },
                {
                    text: "ContainerLocation",
                    value: "container_location.container_location",
                    sortable: false,
                },
                {
                    text: "ContainerLocatedAt",
                    value: "container_located_at",
                    sortable: false,
                },                
                {
                    text: "ContainerLocation2",
                    value: "container_location2",
                    sortable: false,
                },
                {
                    text: "ContainerLocatedAt2",
                    value: "container_located_at2",
                    sortable: false,
                },
                {
                    text: "ContainerLocation3",
                    value: "container_location3",
                    sortable: false,
                },
                {
                    text: "ContainerLocatedAt3",
                    value: "container_located_at3",
                    sortable: false,
                },
                {
                    text: "ContainerPosition",
                    value: "container_position",
                    sortable: false,
                },           
                {
                    text: "SurveyStatus",
                    value: "survey.status_code",
                    sortable: false,
                },
                {
                    text: "JobOrderStatus[Latest]",
                    value: "status_history[0].status.status_code",
                    sortable: false,
                },
                {
                    text: "EquipmentControl",
                    value: "equipment_control",
                    sortable: false,
                },                  
                {
                    text: "Pictures",
                    value: "pictures",
                    sortable: false,
                },
                {
                    text: "CreatedBy",
                    value: "user.name",
                    sortable: false,
                },
                {
                    text: "CreatedAt",
                    value: "created_at",
                    sortable: false,
                },
            ],
            headersForNonAdmin: [
                {
                    text: "TransactionId",
                    value: "transaction_id",
                    sortable: false,
                },
                {
                    text: "Container#",
                    value: "container_number",
                    sortable: false,
                },
                {
                    text: "CompanyName",
                    value: "company.name",
                    sortable: false,
                },
                {
                    text: "Remark",
                    value: "remark.remark_name",
                    sortable: false,
                },
                {
                    text: "Destination",
                    value: "destination.destination_type",
                    sortable: false,
                },
                {
                    text: "RepairClassification",
                    value: "repair_classification.repair_classification",
                    sortable: false,
                },
                {
                    text: "SurveyStatus",
                    value: "survey.status_code",
                    sortable: false,
                },
                {
                    text: "JobOrderStatus[Latest]",
                    value: "status_history[0].status.status_code",
                    sortable: false,
                },
                // {
                //     text: "JobOrderStatus",
                //     value: "status_history[0].status.status_code",
                //     sortable: false,
                // },
                {
                    text: "GateIn",
                    value: "gate_in",
                    sortable: false,
                },
                {
                    text: "ContainerLocation",
                    value: "container_location.container_location",
                    sortable: false,
                },
                {
                    text: "ContainerLocatedAt",
                    value: "container_located_at",
                    sortable: false,
                },                
                {
                    text: "ContainerLocation2",
                    value: "container_location2",
                    sortable: false,
                },
                {
                    text: "ContainerLocatedAt2",
                    value: "container_located_at2",
                    sortable: false,
                },
                {
                    text: "ContainerLocation3",
                    value: "container_location3",
                    sortable: false,
                },
                {
                    text: "ContainerLocatedAt3",
                    value: "container_located_at3",
                    sortable: false,
                },
                {
                    text: "ContainerPosition",
                    value: "container_position",
                    sortable: false,
                },
                {
                    text: "TruckDetails",
                    value: "truck_details",
                    sortable: false,
                },
                {
                    text: "SideLifterDetails",
                    value: "side_lifter_details",
                    sortable: false,
                },
                {
                    text: "EquipmentControl",
                    value: "equipment_control",
                    sortable: false,
                },                
                {
                    text: "Pictures",
                    value: "pictures",
                    sortable: false,
                },
                {
                    text: "CreatedBy",
                    value: "user.name",
                    sortable: false,
                },
                {
                    text: "CreatedAt",
                    value: "created_at",
                    sortable: false,
                },
            ],
            transactions: [],
            equipmentControlDialog: false,
            pictureTempUrls: null,
            damagePictureTempUrls: null,            
            currentItem: null,
            currentContainerNumber: null,
            currentTransactionId: null,
            currentContainerSize: null,
            currentContainerType: null,
            currentContainerClass: null,
            currentManufacturingDate: null,
            currentTransactionId: null,
            currentCedexCode: null,
            currentJobOrderServices: [],            
            pictureHeaders: [
                {
                    text: "FileName",
                    value: "file_name",
                    sortable: true,
                },
                {
                    text: "Status",
                    value: "status",
                    sortable: true,
                },
                {
                    text: "CreatedAt",
                    value: "created_at",
                    sortable: true,
                },
                {
                    text: "ViewPictures",
                    value: "view_pictures",
                    sortable: true,
                },
                {
                    text: "DamagePictures",
                    value: "damage_pictures",
                    sortable: true,
                },
                {
                    text: "PostServicePictures",
                    value: "post_service_pictures",
                    sortable: true,
                },
            ],
            pictures: [],
            // statuses: [
            //     {
            //         status_id: 'S-02',
            //         status_code: 'SURVEYED',
            //     },
            //     {
            //         status_id: 'S-05',
            //         status_code: 'GATEIN',
            //     },
            //     {
            //         status_id: 'S-06',
            //         status_code: 'CONTAINERLOCATED',
            //     },
            //     {
            //         status_id: 'S-07',
            //         status_code: 'JOBSTARTED',
            //     },
            //     {
            //         status_id: 'S-08',
            //         status_code: 'JOBCLOSED',
            //     },
            //     {
            //         status_id: 'S-09',
            //         status_code: 'GATEOUT',
            //     },
            // ],
            // remarks: ['PASS', 'REJECTED', 'SURVEY ONLY'],
            damagePicturesDialog: false,
            damagePictureHeaders: [
                {
                    text: "FileName",
                    value: "file_name",
                    sortable: true,
                },
                {
                    text: "Download Damage Picture",
                    value: "download_damage_picture",
                    sortable: true,
                },
                {
                    text: "CreatedAt",
                    value: "created_at",
                    sortable: true,
                },
            ],
            damagePictures: [],
            postServicePictures: [],
            postServicePicturesDialog: false,
            postServicePictureHeaders: [
                {
                    text: "FileName",
                    value: "file_name",
                    sortable: true,
                },
                {
                    text: "Download Post Service Picture",
                    value: "download_post_service_picture",
                    sortable: true,
                },
                {
                    text: "CreatedAt",
                    value: "created_at",
                    sortable: true,
                },
            ],
            inventoryMovementReportDialog: false,
            inventoryMovementReportHeaders: [
                {
                    text: "Company",
                    value: "company_name",
                    sortable: true,
                },                
                {
                    text: "Booking",
                    value: "S-01",
                    sortable: true,
                },                
                {
                    text: "Survey",
                    value: "S-02",
                    sortable: true,
                }, 
                {
                    text: "Rejected",
                    value: "S-03",
                    sortable: true,
                },                                               
                {
                    text: "Survey Only",
                    value: "S-04",
                    sortable: true,
                },                                               
                {
                    text: "Gate In",
                    value: "S-05",
                    sortable: true,
                },                                               
                {
                    text: "Stackyard",
                    value: "S-06",
                    sortable: true,
                },                
                {
                    text: "Job Start",
                    value: "S-07",
                    sortable: true,
                },                
                {
                    text: "Job Close",
                    value: "S-08",
                    sortable: true,
                },                               
                {
                    text: "Gate Out",
                    value: "S-09",
                    sortable: true,
                },                
                {
                    text: "Total",
                    value: "total",
                    sortable: true,
                },                
                          
            ],
            inventoryMovementReportData: [],
            location1SelectionFormDialog: false,
            containerLocations: [],
            container_location: null,
            location2SelectionFormDialog: false,
            containerLocations2: ["Stackyard", "ATI-HRD Pool", "HRD Withdrawal"],
            containerLocation2: null,
        }
    },
    mounted() {
        if( !this.$store.state.user.role.match(/^sitc$|^tsline$|^msk$|^dp$|^su$|admin|surveyor|ec|mnr|gater/) ) {
            alert('You have not access right to enter the area...');
            this.$router.push('/');
        }
        if( this.$route.params.transaction_id && this.$route.params.tab ) {
            this.search = this.$route.params.transaction_id;
        } else {
            this.search = null;
        }

        if( this.$store.state.user.role !== 'admin' ) {
            this.headers = this.headersForNonAdmin;
        }

        this.getDestinations();
        this.loadTransactions2();
        // this.getStatuses();
        // this.getRemarks();
        if( !this.$store.state.routes.some(obj => obj.href == this.$route.path) ) {
            this.$store.commit(
                'addRoute',
                {
                    text: this.$route.path,
                    disabled: false,
                    href: this.$route.path,                
                }            
            );
        }
    },
    methods: {
        loadTransactions2: function() {
            this.overlay = true;
            this.loading = true;
            this.axios.post(
                '/api/get_transactions2',
                {
                    user: this.$store.state.user,
                    page: this.page,
                    itemsPerPage: this.itemsPerPage,
                    search: this.search,
                    activityType: this.activityType,
                    destination_id: this.destination,
                    fromDate: this.fromDate,
                    untilDate: this.untilDate,
                    fromTime: this.formatFromTime(this.fromTime),
                    untilTime: this.formatUntilTime(this.untilTime),
                }
            ).then(response => {
                    // console.log(response.data);
                    if(response.status === 200) {
                        this.transactions = response.data.data;
                        // console.log(this.transactions)
                        this.totalNumberOfRecords = response.data.total;
                        this.pageCount = Math.ceil(response.data.total / this.itemsPerPage);
                    } else {
                        this.$store.commit('logOut');
                    }

                }).catch(error => {
                    console.log(error);
                    this.$store.commit('logOut');
                }).finally(() => {
                    this.overlay = false;
                    this.loading = false;
                });
        },       
        getDestinations: function() {
            this.overlay = true;
            this.loading = true;
            this.axios.post(
                '/api/get_destinations'
            ).then(response => {
                    // console.log(response.data);
                if(response.status === 200) {
                const allItem = {
                    destination_id: 'ALL',
                    destination_type: 'ALL',
                };

                this.destinations = [allItem, ...response.data];
                } else {
                    this.$store.commit('logOut');
                }

            }).catch(error => {
                console.log(error);
                this.$store.commit('logOut');
            }).finally(() => {
                this.overlay = false;
                this.loading = false;
            });            
        },        
        gateIn: function(item) {

            this.overlay = true;
            this.loading = true;

            this.axios.post(
                '/api/gate_in',
                {
                    job_order_id: item.job_order_id,
                    user_id: this.$store.state.user.id,
                    transaction_id: item.transaction_id
                }
            ).then(response => {
                this.loadTransactions2();
            }).catch(error => {
                console.log(error);
            }).finally(() => {
                this.overlay = true;
                this.loading = true;
            });
        },
        // getRemarks: function() {
        //     this.axios.post('/api/get_remarks')
        //         .then(response => {
        //             this.remarks = response.data;
        //         }).catch(error => {
        //             console.log(error);
        //         });
        // },
        openImagesDialog: function(item) {
            // console.log(item)
            this.imagesDialog = true;
            this.currentItem = item;
            this.currentContainerNumber = this.currentItem.container_number;
            this.currentTransactionId = this.currentItem.transaction_id;
            this.pictures = this.currentItem.pictures;
        },
        downloadPicture: function (item) {
        this.overlay = true;
        axios
            .post(
            "/api/download_picture",
            {
                container_number: item.container_number,
                transaction_id: item.transaction_id,
                name: item.file_name,
            },
            {
                responseType: "blob",
            }
            )
            .then((response) => {
            this.overlay = false;
            const fileURL = window.URL.createObjectURL(
                new Blob([response.data], { type: "image/png" })
            );
            const fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.target = "_blank";
            document.body.appendChild(fileLink);
            fileLink.click();
            document.body.removeChild(fileLink);
            });
        },
        downloadDamagePicture: function (item) {
        this.overlay = true;
        axios
            .post(
            "/api/download_damage_picture",
            {
                container_number: this.currentContainerNumber,
                transaction_id: this.currentTransactionId,
                name: item.file_name,
            },
            {
                responseType: "blob",
            }
            )
            .then((response) => {
            this.overlay = false;
            const fileURL = window.URL.createObjectURL(
                new Blob([response.data], { type: "image/png" })
            );
            const fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.target = "_blank";
            document.body.appendChild(fileLink);
            fileLink.click();
            document.body.removeChild(fileLink);
            });
        },
        downloadPostServicePicture: function (item) {
        this.overlay = true;
        axios
            .post(
            "/api/download_post_service_picture",
            {
                container_number: this.currentContainerNumber,
                transaction_id: this.currentTransactionId,
                job_order_service_id: item.job_order_service_id,
                name: item.file_name,
            },
            {
                responseType: "blob",
            }
            )
            .then((response) => {
            this.overlay = false;
            const fileURL = window.URL.createObjectURL(
                new Blob([response.data], { type: "image/png" })
            );
            const fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.target = "_blank";
            document.body.appendChild(fileLink);
            fileLink.click();
            document.body.removeChild(fileLink);
            });
        },
        openDamagePicturesDialog: function(item) {
            // console.log(item)
            this.damagePicturesDialog = true;
            this.damagePictures = item.damage_pictures;
            this.postServicePictures = item.post_service_pictures;
        },
        openPostServicePicturesDialog: function(item) {
            // console.log(item)
            this.postServicePicturesDialog = true;
            this.postServicePictures = item.post_service_pictures;
        },
        changePage: function() {
            this.loadTransactions2();
        },
        searchByKeyword: function() {
            if(!this.search) {
                this.page = 1;
                this.loadTransactions2();                
                return false;
            }
            this.search = this.search.toUpperCase();

            if( !this.search.match(/^[A-Z]{4}[0-9]{7}$/)) {
                return false;
            }

            this.page = 1;
            this.loadTransactions2();
        },     
        downloadInventoryMovementReportMain: function() {
            this.loading = true;
            this.overlay = true;
            axios.post(
                '/api/download_inventory_movement_report_excel_main',
                {
                    fromDate: this.fromDate,
                    untilDate: this.untilDate,
                    destination_id: this.destination,
                    fromTime: this.formatFromTime(this.fromTime),
                    untilTime: this.formatUntilTime(this.untilTime),
                    activityType: this.activityType,
                }
            ).then(response => {
                const fileLink = document.createElement("a");
                fileLink.href = response.data['file'];
                fileLink.download = 'InventoryMovementReport_' + moment().format('YYYYMMDD') + '.xlsx';
                fileLink.target = "_blank";
                document.body.appendChild(fileLink);
                fileLink.click();
                document.body.removeChild(fileLink);
            }).catch(error => {
                console.log(error);
            }).finally(() => {
                this.loading = false;
                this.overlay = false;
            });
        },
        downloadInventoryMovementReport: function() {
            this.loading = true;
            this.overlay = true;
            axios.post(
                '/api/download_inventory_movement_report_excel2',
                {
                    fromDate: this.fromDate,
                    untilDate: this.untilDate,
                    fromTime: this.formatFromTime(this.fromTime),
                    untilTime: this.formatUntilTime(this.untilTime),
                    activityType: this.activityType,
                }
            ).then(response => {
                const fileLink = document.createElement("a");
                fileLink.href = response.data['file'];
                fileLink.download = 'InventoryMovementReport_' + moment().format('YYYYMMDD') + '.xlsx';
                fileLink.target = "_blank";
                document.body.appendChild(fileLink);
                fileLink.click();
                document.body.removeChild(fileLink);
            }).catch(error => {
                console.log(error);
            }).finally(() => {
                this.loading = false;
                this.overlay = false;
            });
        },
        getInventoryMovementReportData: function() {
            axios.post(
                '/api/get_inventory_movement_report_data2',
                {
                    fromDate: this.fromDate,
                    untilDate: this.untilDate,
                    fromTime: this.formatFromTime(this.fromTime),
                    untilTime: this.formatUntilTime(this.untilTime),
                    // activityType: this.activityType,
                }
            ).then(response => {
                this.inventoryMovementReportData = response.data;

            }).catch(error => {
                this.loading = false;
                this.overlay = false;                
                console.log(error);
            });
        },
        openLocation1SelectionFormDialog: function(item) {
            this.location1SelectionFormDialog = true;
            this.currentItem = item;
            this.currentContainerNumber = item.container_number;
            this.getContainerLocations();
        },
        putTimestampInContainerLocatedAt: function() {
            this.loading = true;
            this.axios.post(
                '/api/put_timestamp_in_container_located_at',
                {
                    transaction_id: this.currentItem.transaction_id,
                    created_by: this.$store.state.user.id,
                    container_location: this.container_location,
                }            
            )
                .then(response => {
                    if(response.status == 200) {
                        this.location1SelectionFormDialog = false;
                        this.loadTransactions2();
                    }
                }).catch(error => {
                    console.log(error);
                }).finally(() => {
                    this.overlay = false;
                    this.loading = false;
                });            
        },
        openInventoryMovementReportDialog: function() {
            this.inventoryMovementReportDialog = true;
            this.getInventoryMovementReportData();
        },
        getContainerLocations: function() {
            this.overlay = true;
            this.axios.post(
                '/api/get_container_locations'
            ).then(response => {
                this.containerLocations = response.data;
                // console.log(this.containerLocations);
            }).catch(error => {
                console.log(error);
            }).finally(() => {
                this.overlay = false;
            });
        },
        openLocation2SelectionFormDialog: function(item) {
            this.location2SelectionFormDialog = true;
            this.currentItem = item;
            this.currentContainerNumber = this.currentItem.container_number;            
        },
        setLocation2: function() {
            this.overlay = true;
            this.loading = true;
            this.axios.post(
                '/api/set_location2',
                {
                    transaction_id: this.currentItem.transaction_id,
                    container_location2: this.containerLocation2
                }            
            )
                .then(response => {
                    if(response.status == 200) {
                        this.location2SelectionFormDialog = false;
                        this.loadTransactions2();
                    }
                }).catch(error => {
                    console.log(error);
                }).finally(() => {
                    this.overlay = false;
                    this.loading = false;
                });    
        },
        formatFromTime(minutes) {
            const h = String(Math.floor(minutes / 60)).padStart(2, '0');
            const m = String(minutes % 60).padStart(2, '0');
            return `${h}:${m}:00`;
        },
        formatUntilTime(minutes) {
            const h = String(Math.floor(minutes / 60)).padStart(2, '0');
            const m = String(minutes % 60).padStart(2, '0');
            return `${h}:${m}:00`;
        },
        formatTime(value) {
            const hours = Math.floor(value / 60);
            const minutes = value % 60;
            return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
        } ,      
        jobOrderStatus: function(item) {
            // console.log(item.status_history[0].status.status_code)
            return item.status_history?.[0]?.status?.status_code;
        },
        openequipmentControlDialog: function(item) {
            // console.log(item)

            this.equipmentControlDialog = true;
            this.currentContainerNumber = item.container_number;
            this.currentContainerNumber = item.container_number;
            this.currentContainerSize = item.size.size;
            this.currentContainerType = item.type.type;
            this.currentContainerClass = item.class.class;
            this.currentManufacturingDate = item.manufacturing_date;
            this.currentTransactionId = item.transaction_id;
            this.currentCedexCode = item.cedex_code;
            if(item.job_order) {
                // console.log(item)
                this.currentJobOrderServices = item.job_order.job_order_services;
            }
            this.getPictureTempUrls();
            this.getDamagePictureTempUrls();
        },
        getPictureTempUrls: function() {
            this.overlay = true;
            this.loading = true;
            this.axios.post(
                '/api/get_picture_temp_urls',
                {
                    container_number: this.currentContainerNumber,
                    transaction_id: this.currentTransactionId,
                },
                // {
                //     responseType: "blob",
                // }
            ).then(response => {
                // console.log(response.data[0])
                this.pictureTempUrls = response.data;
            }).catch(error => {
                console.log(error);
            }).finally(() => {
                this.overlay = false;
                this.loading = false;
            });
        },
        getDamagePictureTempUrls: function() {
            this.overlay = true;
            this.loading = true;
            this.axios.post(
                '/api/get_damage_picture_temp_urls',
                {
                    container_number: this.currentContainerNumber,
                    transaction_id: this.currentTransactionId,
                },
                // {
                //     responseType: "blob",
                // }
            ).then(response => {
                // console.log(response.data)
                this.damagePictureTempUrls = response.data;
            }).catch(error => {
                console.log(error);
            }).finally(() => {
                this.overlay = false;
                this.loading = false;
            });
        },       
        spreadSheetGenerationTest: function() {
            this.overlay = true;
            this.loading = true;
            axios.post(
                '/api/spreadsheet_generation_test',
                {
                    container_number: this.currentContainerNumber,
                    transaction_id: this.currentTransactionId,
                    currentContainerNumber: this.currentContainerNumber,
                    currentContainerClass: this.currentContainerClass,
                    currentContainerType: this.currentContainerType,
                    currentContainerSize: this.currentContainerSize,
                    currentManufacturingDate: this.currentManufacturingDate,
                    currentTransactionId: this.currentTransactionId,
                    currentCedexCode: this.currentCedexCode,
                    currentJobOrderServices: this.currentJobOrderServices
                }
            ).then(response => {
                // console.log(response.data['file'])
                // console.log(this.dates)
                // return false;
                this.downloading = false;
                this.overlay = false;
                const fileLink = document.createElement("a");
                fileLink.href = response.data['file'];
                fileLink.download = 'EquipmentControl' + moment().format('YYYYMMDD') + '.xlsx';
                fileLink.target = "_blank";
                document.body.appendChild(fileLink);
                fileLink.click();
                document.body.removeChild(fileLink);
            }).catch(error => {
                console.log(error);
            }).finally(() => {
                this.overlay = false;
                this.loading = false;
            });
        },     
        getTotal(item) {
            const keys = ['S-01','S-02','S-03','S-04','S-05','S-06','S-07','S-08','S-09'];
            return keys.reduce((sum, key) => {
            const value = Number(item[key]);
            return sum + (isNaN(value) ? 0 : value);
            }, 0);
        },
        calculateColumnTotal(data, column) {
            return data.reduce((sum, value) => {
                const num = Number(value[column]);
                return sum + (isNaN(num) ? 0 : num);
            }, 0);
        },
    },   
    filters: {
        formatDate: function (date) {
            return date !== null ? moment(date).format("MM-DD-YYYY hh:mm:ss A") : '';
        },
    },
    watch: {
        fromDate: function() {
            this.loadTransactions2();
        },
        untilDate: function() {
            this.loadTransactions2();
        },
        activityType: function() {
            this.loadTransactions2();
        },
        destination: function() {
            this.loadTransactions2();
        }
    },
    computed: {
        picturesWithIndex() {
            const pictures = this.pictures || [];
            const tempUrls = this.pictureTempUrls || [];

            return pictures.map((pic, i) => ({
                ...pic,
                tempUrl: tempUrls[i] || null,
            }));
        },
        filteredActivityTypes() {
            const role = this.$store.state.user.role;

            const allTypes = [
            { value: 'ALL', text: 'ALL' },
            { value: 'S-01', text: 'BOOKED' },
            { value: 'S-02', text: 'SURVEYED' },
            { value: 'S-05', text: 'GATEIN' },
            { value: 'S-07', text: 'JOBSTARTED' },
            { value: 'S-08', text: 'JOBCLOSED' },
            { value: 'S-09', text: 'GATEOUT' }
            ];

            if (role === 'dp') {
                return allTypes.filter(t => ['S-08', 'S-09'].includes(t.value));
            }

            if (role === 'sitc') {
                return allTypes.filter(t => ['S-02', 'S-05'].includes(t.value));
            }

            if (role === 'su') {
                return allTypes;
            }
        },
        filteredDestinations() {
            const role = this.$store.state.user.role;
            const allDestinations = [
                {value: 'D-01', text: 'TANZA'},
                {value: 'D-02', text: 'BILT'},
                {value: 'D-03', text: 'MILT'},
                {value: 'D-04', text: 'ATI-SH'},
                {value: 'D-05', text: 'DIVERT TO TCTI'},
            ];

            if (role === 'sitc') {
                return allDestinations.filter(d => ['D-03'].includes(d.value))
            } else {
                return allDestinations;
            }
        }
    }
}
</script>